import type { AspectRatioEnum } from '@goldcast/api/content';
import type { IconName } from '@/components/atoms/Icon';

// Mirrors the backend contract so the tiles and the API payload cannot drift apart.
export type AspectRatioValue = AspectRatioEnum;

export type AspectRatioOption = {
  value: AspectRatioValue;
  ratioLabel: string;
  subLabel: string;
  icon: IconName;
  platformIcons: IconName[];
};

export const ASPECT_RATIO_OPTIONS: AspectRatioOption[] = [
  {
    value: '16:9',
    ratioLabel: '16:9',
    subLabel: 'Landscape',
    icon: 'IconRectangle',
    platformIcons: ['IconBrandYoutubeFilled', 'IconBrandLinkedinFilled', 'IconWorld']
  },
  {
    value: '9:16',
    ratioLabel: '9:16',
    subLabel: 'Portrait',
    icon: 'IconRectangleVertical',
    platformIcons: ['IconBrandYoutubeFilled', 'IconBrandTiktokFilled', 'IconBrandInstagram']
  },
  {
    value: '1:1',
    ratioLabel: '1:1',
    subLabel: 'Square',
    icon: 'IconSquare',
    platformIcons: ['IconBrandLinkedinFilled', 'IconBrandX', 'IconBrandInstagram']
  }
];

// Matches the backend default for HighlightReelGenerate.aspect_ratio.
export const DEFAULT_ASPECT_RATIO: AspectRatioValue = '16:9';
